import {Outlet, useNavigate} from 'react-router-dom';
import HeaderBox from './HeaderBox';
import Sidebar from './Sidebar';
import {useSelector} from "react-redux";
import Cookies from 'js-cookie';
import {useEffect} from "react";

const FullLayout = () => {
    const navigate = useNavigate();

    const sidebarStatus = useSelector((state) => state.SettingRedux.sidebarStatus);
    const token = Cookies.get('token')


    useEffect(() => {
        if (!token) {

            navigate(`login`);
        }
    }, [navigate,token]);
    return (
        <div className='bg-gray-100 ' style={{minHeight: 'calc(100vh - 56px)'}}>
            {token && <><HeaderBox/>


                <Sidebar/>
                <div
                    className={`${sidebarStatus === 1 ? 'lg:mr-64' : sidebarStatus === 2 && 'lg:mr-20'}  mt-14 bg-gray-100 sideBarTransition z-10`}>
                    <div className='p-1 sm:p-2 md:p-4 '>

                        <Outlet/>

                    </div>
                </div>
            </>
            }
        </div>)


};

export default FullLayout;
